export default function ghollakProfitCalculationStatus(status) {
    let text;
    switch (status) {
        case 100: {
            text = "محاسبه شده";
            break;
        }
        case 101: {
            text = "ارسال برای پرداخت";
            break;
        }
        case 102: {
            text = "پرداخت شده";
            break;
        }
        default: {
            text = "محاسبه نشده";
            break;
        }
    }
    return text
}
